import { render, staticRenderFns } from "./vipParctice.vue?vue&type=template&id=7a779912&scoped=true"
import script from "./vipParctice.vue?vue&type=script&lang=js"
export * from "./vipParctice.vue?vue&type=script&lang=js"
import style0 from "./vipParctice.vue?vue&type=style&index=0&id=7a779912&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a779912",
  null
  
)

export default component.exports